import { StyledIconButton, StyledPauseIcon, StyledPlayIcon } from './styled';

type PropsType = {
  isPlaying: boolean;
  play: () => void;
  pause: () => void;
};

const PlaybackButton = ({ isPlaying, play, pause }: PropsType) => (
  <StyledIconButton onClick={isPlaying ? pause : play}>
    {isPlaying ? <StyledPauseIcon /> : <StyledPlayIcon />}
  </StyledIconButton>
);

export default PlaybackButton;
